<div
  id="default-page"
  class="inner-scroll"
  fxLayout="row"
  fxLayoutAlign="start">
  <div id="default-page-intro" fxFlex fxHide fxShow.gt-sm>
    <div
      class="title"
      [@animate]="{ value: '*', params: { delay: '50ms', y: '25px' } }">
      {{ 'GENERAL.TITLE.SITE' | translate }}
    </div>
  </div>
  <div
    id="default-page-form-wrapper"
    [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }">
    <div id="default-page-form">
      <div class="title">{{ 'RESET-PWD.CHANGEPWD' | translate }}</div>
      <form name="securityform" [formGroup]="securityform">
        <mat-form-field appearance="outline" class="field-container">
          <mat-label>{{ 'SECURITY.OLDPASSWORD.TITLE' | translate }}</mat-label>
          <app-pass-visibility #toggleOld matSuffix></app-pass-visibility>
          <input
            matInput
            formControlName="oldpassword"
            required
            [type]="toggleOld.type"
            placeholder=""
            [formControl]="securityform.get('oldpassword') | formPipe"
            autoComplete="on" />
          @if (securityform.get('oldpassword').invalid) {
            <mat-error class="error-password">
              {{ getErrorMessageOldPassword() }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="field-container">
          <mat-label>{{ 'SECURITY.PASSWORD.TITLE' | translate }}</mat-label>
          <app-pass-visibility #toggleNew matSuffix></app-pass-visibility>
          <input
            matInput
            formControlName="password"
            required
            [type]="toggleNew.type"
            placeholder=""
            [formControl]="securityform.get('password') | formPipe"
            autoComplete="on" />
          @if (securityform.get('password').invalid) {
            <mat-error class="error-password">
              {{ getErrorMessage() }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="field-container">
          <mat-label>{{
            'SECURITY.PASSWORDCONFIRMATION.TITLE' | translate
          }}</mat-label>
          <app-pass-visibility #toggleConfirm matSuffix></app-pass-visibility>
          <input
            matInput
            formControlName="passwordConfirmation"
            required
            [type]="toggleConfirm.type"
            placeholder=""
            [formControl]="securityform.get('passwordConfirmation') | formPipe"
            autoComplete="on" />
        </mat-form-field>
        <div class="error-container">
          @if (securityform.hasError('passwordNotMatch')) {
            <mat-error class="message-box error">
              {{ 'ERROR.IDENTICALPSWD' | translate }}
            </mat-error>
          }
        </div>
        <button
          mat-raised-button
          class="submit-button"
          color="accent"
          (click)="changePwd()"
          aria-label="RESET MY PASSWORD"
          [disabled]="securityform.invalid || isBusy">
          {{ 'SECURITY.FORM.SUBMIT' | translate }}
        </button>
        @if (isBusy) {
          <div
            class="general-container"
            fxLayout="column"
            fxLayoutAlign="center center">
            <mat-progress-spinner
              [color]="spinner.color"
              [mode]="spinner.mode"
              [value]="spinner.value"
              [diameter]="spinner.diameter">
            </mat-progress-spinner>
            <div stlye="margin-top:12px">
              {{ 'GENERAL.LOADING' | translate }}
            </div>
          </div>
        }
        @if (isErrorUpdatePwd) {
          <div class="general-container">
            <div class="message-box error">
              <app-error-message [error]="error.error" />
            </div>
          </div>
        }
        @if (isPwdUpdated) {
          <div class="general-container">
            <div class="message-box success">
              {{ 'SECURITY.FORM.SUCCESS' | translate }}
            </div>
          </div>
        }
      </form>

      <div class="logout-sidenav">
        <button
          class="logout"
          mat-raised-button
          color="warn"
          (click)="logout()">
          <mat-icon class="logout-icon">exit_to_app</mat-icon>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </div>
</div>
